
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center glass-card rounded-xl p-12 max-w-md">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-xl text-white/70 mb-8">Oops! Page not found</p>
        <p className="text-white/70 mb-6">The page you were looking for at {location.pathname} doesn't exist.</p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => navigate('/')}
            className="flex items-center"
          >
            <Home className="h-4 w-4 mr-2" />
            Return to Home
          </Button>
          
          {user && (
            <Button 
              onClick={() => navigate('/dashboard')}
              variant="outline" 
              className="flex items-center border-[#9E7C47] text-[#9E7C47] hover:bg-[#9E7C47] hover:text-white"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go to Dashboard
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
